import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  constructor() { }

  set(key: string, value: string): this {
    sessionStorage.setItem(key, value);
    return this;
  }

  get(key: string) {
    return sessionStorage.getItem(key);
  }

  remove(key: string): this {
    sessionStorage.removeItem(key);
    return this;
  }

  getObject(key: string): any {
    return JSON.parse(sessionStorage[key] || '{}');
  }
}
